import { useEffect, useState } from "react";
import { useGame } from "~/app";
import { AudioPaths, soundPlayer } from "~/infra";
import { useViewingPlayerOpt } from "~/jsx/hook";

export const useYourTurn = () => {
  const { game } = useGame();
  const { currentPlayer } = game;
  const [lastPlayerId, setLastPlayerId] = useState(currentPlayer.id);
  const viewingPlayer = useViewingPlayerOpt();
  useEffect(() => {
    if (
      lastPlayerId !== currentPlayer.id &&
      viewingPlayer?.id === currentPlayer.id
    ) {
      soundPlayer.play(AudioPaths.yourTurn);
      setLastPlayerId(currentPlayer.id);
    }
  }, [lastPlayerId, setLastPlayerId, currentPlayer.id]);
};
